<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-new="false"
                        :show-button-export="true"
                        :show-widgets="true"
                        :show-button-other-action-export="true"
                        file-type-other-action-export="xls"
                        :reload-table-server.sync="reloadTableServer">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
                            <el-tooltip content="Exportar Formato SUNAT 13.1"
                                        effect="dark"
                                        placement="top">
                                <x-button-icon icon="fa-light fa-download"
                                               class="x-button-icon-small"
                                               @click="clickExportFormatSunat(row)"></x-button-icon>
                            </el-tooltip>
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>

        <modal-report :showDialog.sync="showDialog"></modal-report>
    </div>
</template>

<script>

import ModalReport from "./partials/Modal.vue";
import XTableServer from "../../../../components/Form/XTableServer.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";
import queryString from "query-string";

export default {
    name: 'InventoryReportValuedKardex',
    components: {
        XButtonIcon, XButtonDownload, XButtonPrimary, XTableServer, ModalReport
    },
    data() {
        return {
            title: 'Kardex valorizado',
            resource: 'inventory/valued-kardex',
            recordId: null,
            showDialog: false,
            showDialogInformation: false,
            reloadTableServer: false,
        }
    },
    methods: {
        clickCreate() {
            this.showDialog = true;
        },
        async clickExportFormatSunat(row) {
            let type = 'xls'
            await this.$http({
                url: `/${this.resource}/excel-format-sunat`,
                method: 'POST',
                responseType: 'blob',
                data: row.filters
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    let fileName = 'Reporte_Kardex_Valorizado_Sunat_13_' + moment().format('YYYYMMDDHHmmss')
                    let extension = (type === 'xls') ? '.xlsx' : '.pdf'
                    link.setAttribute('download', fileName + extension)
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(error => {
                    console.log(error)
                })
        },
    }
}
</script>
